import messageResource from "../messageResource";
import ArchiveDialog from "./ArchiveDialog";

export default class ArchiveProjectDialog extends ArchiveDialog {
    constructor($container) {
        super($container, messageResource.getMessage("common.project"));
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/ArchiveProjectDialog.js